"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadMultipart = exports.getImageDataUrl = exports.getAttachmentUrl = exports.downloadFileUsingAnonymousUser = exports.downloadFile = void 0;
const BaseClient_1 = require("@juvare/platform-sdk-js/BaseClient");
const getAppName_1 = require("../../ui/utils/getAppName");
const buffer_1 = require("buffer");
function downloadFile(param) {
    return __awaiter(this, void 0, void 0, function* () {
        if (BaseClient_1.baseClientDefaults.tokenProvider) {
            const jwt = yield BaseClient_1.baseClientDefaults.tokenProvider.onTokenRequest();
            downloadFileUsingJwt(param, jwt);
        }
        else {
            window.open(getAttachmentUrl(param), '_blank');
        }
    });
}
exports.downloadFile = downloadFile;
function downloadFileUsingJwt(param, jwt) {
    const form = document.createElement('form');
    form.method = 'post';
    form.target = '_blank';
    form.action = BaseClient_1.baseClientDefaults.baseUrl + '/api/v1/attachment/get';
    const inputs = [];
    inputs.push(`<input type="hidden" name="entity" value="${param.entity}">`);
    inputs.push(`<input type="hidden" name="entityId" value="${param.entityId}">`);
    inputs.push(`<input type="hidden" name="jwt" value="${jwt}">`);
    inputs.push(`<input type="hidden" name="key" value="${param.key}">`);
    if (param.downloadFileName) {
        inputs.push(`<input type="hidden" name="downloadFileName" value="${param.downloadFileName}">`);
    }
    if (param.version) {
        inputs.push(`<input type="hidden" name="version" value="${param.version}">`);
    }
    form.innerHTML = inputs.join();
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function downloadFileUsingAnonymousUser(param, additionalParams) {
    const form = document.createElement('form');
    form.method = 'post';
    form.target = '_blank';
    form.action = BaseClient_1.baseClientDefaults.baseUrl + '/api/v1/anonymous/attachment/get';
    const inputs = [];
    inputs.push(`<input type="hidden" name="app" value="${(0, getAppName_1.getAppName)()}">`);
    inputs.push(`<input type="hidden" name="entity" value="${param.entity}">`);
    inputs.push(`<input type="hidden" name="entityId" value="${param.entityId}">`);
    inputs.push(`<input type="hidden" name="key" value="${param.key}">`);
    for (const key in additionalParams) {
        inputs.push(`<input type="hidden" name="${key}" value="${additionalParams[key]}">`);
    }
    if (param.downloadFileName) {
        inputs.push(`<input type="hidden" name="downloadFileName" value="${param.downloadFileName}">`);
    }
    if (param.version) {
        inputs.push(`<input type="hidden" name="version" value="${param.version}">`);
    }
    form.innerHTML = inputs.join();
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
}
exports.downloadFileUsingAnonymousUser = downloadFileUsingAnonymousUser;
function getAttachmentUrl(param) {
    const baseUrl = BaseClient_1.baseClientDefaults.baseUrl;
    const entityParam = encodeURIComponent(param.entity);
    const entityIdParam = encodeURIComponent(param.entityId);
    const keyParam = encodeURIComponent(param.key);
    const downloadFileNameParam = param.downloadFileName ? '&downloadFileName=' + encodeURIComponent(param.downloadFileName) : '';
    const versionParam = param.version ? '&version=' + encodeURIComponent(param.version) : '';
    return `${baseUrl}/api/v1/attachment/get?entity=${entityParam}&entityId=${entityIdParam}&key=${keyParam}${downloadFileNameParam}${versionParam}`;
}
exports.getAttachmentUrl = getAttachmentUrl;
/**
 * Generates a data URL for an image.
 *
 * @async
 * @param {AttachmentClient} storage - The AttachmentClient instance used to retrieve image content.
 * @param {string} entity - Name of the entity.
 * @param {string} entityId - Entity id.
 * @param {string} key - Attachment key. Note that this is NOT a file name. The key must match this regex pattern "[a-z][a-zA-Z0-9_]*".
 * @param {number} [version] - Attachment version (optional).
 * @returns {Promise<string>} A Promise that resolves to the data URL of the image.
 */
function getImageDataUrl(storage, entity, entityId, key, version) {
    return __awaiter(this, void 0, void 0, function* () {
        return storage.getContent({ entity, entityId, version, key }).then((response) => {
            const content = buffer_1.Buffer.from(response.content).toString('base64');
            return `data:${response.contentType};base64,${content}`;
        });
    });
}
exports.getImageDataUrl = getImageDataUrl;
function uploadMultipart(client, entity, entityId, file, attachmentKey, progressCallback) {
    return __awaiter(this, void 0, void 0, function* () {
        const contentType = file.type || 'application/octet-stream';
        const { uploadId } = yield client.beginMultipartUpload({
            entity,
            entityId,
            key: attachmentKey,
            contentType,
        });
        const fileSize = file.size;
        let filePosition = 0;
        // S3 limits to 10k parts max if we pick 5mb part size max file size can be 50GB if this is not enough we will need to increase part size
        // Increasing part size might reduce chances of successful part upload
        let partSize = 5 * 1024 * 1024;
        let finished = false;
        let totalUploadedBytes = 0;
        let promises = [];
        const updateProgress = (uploadedBytes) => {
            if (finished) {
                return;
            }
            totalUploadedBytes += uploadedBytes;
            progressCallback === null || progressCallback === void 0 ? void 0 : progressCallback(Math.floor((totalUploadedBytes / fileSize) * 100));
        };
        for (let i = 1; filePosition < fileSize; i++) {
            partSize = Math.min(partSize, fileSize - filePosition);
            const blob = file.slice(filePosition, filePosition + partSize);
            const promise = client.uploadPart({
                uploadId,
                partNumber: i,
                content: blob,
                contentType,
            }, progressCallback ? (uploadedBytes) => updateProgress(uploadedBytes) : undefined, { retry: 3 });
            promises.push(promise);
            if (promises.length === 5) {
                yield Promise.all(promises);
                promises = [];
            }
            filePosition += partSize;
        }
        if (promises.length > 0) {
            yield Promise.all(promises);
        }
        finished = true;
        progressCallback === null || progressCallback === void 0 ? void 0 : progressCallback(100);
        return client.completeMultipartUpload({ uploadId });
    });
}
exports.uploadMultipart = uploadMultipart;
